import { render } from "./Admissions.vue?vue&type=template&id=a241a666&scoped=true"
import script from "./Admissions.vue?vue&type=script&lang=js"
export * from "./Admissions.vue?vue&type=script&lang=js"

import "./Admissions.vue?vue&type=style&index=0&id=a241a666&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a241a666"]])

export default __exports__